import { useLayoutEffect } from "react";

import { Paths, SandboxUrlLoginRedirect, UseLoginLocal } from "configs";
import { useAuth } from "hooks/useAuth";
import { useLocation, Navigate } from "react-router-dom";
import { useAppSelector } from "stores";

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const { status } = useAppSelector((state) => state.auth);
  const { isLoggedIn } = useAuth();
  const location = useLocation();

  useLayoutEffect(() => {
    if (isLoggedIn) return;

    if (!UseLoginLocal) {
      window.location.replace(SandboxUrlLoginRedirect as string);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  if (status !== "AUTH" && UseLoginLocal) {
    // Redirect them to the /sign-in page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to={Paths.SignIn} state={{ from: location }} replace />;
  }

  if (!isLoggedIn && !UseLoginLocal) return null;

  return children;
};

export const ProtectedAuth = ({ children }: { children: JSX.Element }) => {
  const { status } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const previousLocation: Location | undefined = location.state?.from;

  if (status === "AUTH") {
    return (
      <Navigate
        to={
          previousLocation
            ? previousLocation.pathname + previousLocation.search
            : Paths.App
        }
        replace
      />
    );
  }

  return children;
};
